export const CAROUSEL_LABELS = {
    region: 'Solicitações aguardando sua decisão',
    prev: 'Solicitações anteriores',
    next: 'Próximas solicitações',
    page: (page: number, total: number) => `Página ${page} de ${total}`,
    emptyTitle: 'Nenhuma solicitação para aprovar',
    emptyDescription:
        'Quando alguém do seu time pedir férias ou day-off, o pedido aparece aqui para sua decisão.',
} as const;

export const SKELETON_COUNT = 3;
